import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {MenuItem} from "primeng/api";
import {
    ObjectRequestListAttribute
} from "../../../../../../core/shared/dto/object/request/object-request-list-attribute";
import {Sorting} from "../../../../../../core/shared/misc/sorting";
import {
    DtoListAttributeRequestAggregateEnum
} from "../../../../../../core/shared/dto/enum/dto-list-attribute-request-aggregate.enum";
import {
    OverviewStatisticsBaseComponent
} from "../../../../../../core/shared/overview/overview-statistics-base.component";
import {OverviewDto} from "../../../../../../core/shared/overview/dto/overview.dto";
import {WidgetFactory} from "../../../../../../core/shared/widget/service/widget.factory";
import {WidgetData} from "../../../../../../core/shared/widget/widget-data";
import {MvsCoreService} from "../../../../../../core/shared/service/mvs-core.service";
import {WidgetDataParam} from "../../../../../../core/shared/widget/widget-data-param";
import {ObjectRequestListGroupBy} from "../../../../../../core/shared/dto/object/request/object-request-list-group-by";

@Component({
    selector: 'as-statistics',
    templateUrl: 'as-statistics.component.html',
    standalone: false
})
export class AsStatisticsComponent extends OverviewStatisticsBaseComponent implements OnInit, OnChanges, OnDestroy {

    pending: number = 0;
    processed: number = 0;
    inProcess: number = 0;
    unfinished: number = 0;


    appointmentHistoryWidget: WidgetData;
    appointmentByTypeWidget: WidgetData;
    appointmentTypeByGroupWidget: WidgetData;
    recentlyAddedAppointmentsWidget: WidgetData;

    items: MenuItem[] | undefined;

    home: MenuItem | undefined;

    overviewDto: OverviewDto[];

    constructor(
        private router: Router,
        protected route: ActivatedRoute,
        protected coreService: MvsCoreService) {
        super(route, coreService)
    }

    ngOnInit(): void {


        this.items = [
            {label: 'AS Module'},
        ];
        this.overviewDto = [
            {label: 'Pending Registrations', value: 0 },
            {label: 'Processed Registrations', value: 0 },
            {label: 'In-Process Registrations', value: 0 },
            {label: 'Unfinished Registrations', value: 0 }
        ];
        this.home = {icon: 'pi pi-home', routerLink: '/'};
        super.ngOnInit();
        this.initComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();

    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.refreshAppointmentHistoryWidget();
        this.refreshAppointmentByTypeWidget();
        this.refreshAppointmentTypeByGroupWidget();
        this.refreshAddedAppointment();
        this.initialized = true;
    }

    navigateToConfig() {
        this.router.navigate(['/ui/config']);
    }



    refreshAppointmentHistoryWidget() {
        this.appointmentHistoryWidget = WidgetFactory.createWidget(
            'as.appointment.overview.history.widget',
            'Appointment History',
            'history.chart',
            'list',
            'entity.groupBy',
            'as.Appointment',
            WidgetDataParam.create("fieldCategory", "status"),
            WidgetDataParam.create("fieldCategoryCount", "status_count"),
            WidgetDataParam.create("historyPeriodMode", "month"),
            WidgetDataParam.create("fieldDate", "createdDate"),
            WidgetDataParam.create("selectionMode", "single"),
            WidgetDataParam.create("size", "S")
        );
        this.appointmentHistoryWidget.dataProviderListRequest = ObjectRequestListGroupBy.create(
            true,
            this.filterCriteria,
            [],
            ["status", "createdDate"],
            [new ObjectRequestListAttribute("status", "Status", DtoListAttributeRequestAggregateEnum.count)]
        );
    }

    refreshAppointmentByTypeWidget() {
        this.appointmentByTypeWidget = WidgetFactory.createWidgetGroupBy(
            'as.appointment.overview.by.type.widget',
            'Appointment By Type',
            'category',
            'entity.groupBy',
            'as.Appointment',
            'appointmentType',
            'appointmentType_count',
            this.filterCriteria,
            'appointmentType',
            'Anzahl');
    }

    refreshAppointmentTypeByGroupWidget() {
        this.appointmentTypeByGroupWidget = WidgetFactory.createWidgetGroupBy(
            'as.appointment.overview.by.group.widget',
            'Appointment Type By Group',
            'category',
            'entity.groupBy',
            'as.AppointmentType',
            'appointmentGroup',
            'appointmentGroup_count',
            this.filterCriteria,
            'appointmentGroup',
            'Anzahl'
        );
    }

    refreshAddedAppointment() {
        this.recentlyAddedAppointmentsWidget = WidgetFactory.createWidgetTableEntityBasicQl('as.appointment.overview.recently.added.appointment', 'Recent Appointments', 'as.Appointment', this.filterCriteriaForQuery ?? [], [new Sorting('e.createdDate', false)]);
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
